import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, Switch, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { color } from "../../../StyleData/Config";
import PartsReservationModal from "./PartsReservationModal";
import FeedBack from "../../../Component/FeedBack";
import moment from "moment";
import { encode } from "../../../Component/JWT/Formatt";

const PartsReservation = () => {
  const actionAllow = useSelector(state => state.dataRed.actionsAllow);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [reservationStatus, setReservationStatus] = useState([]);
  const [reservationId, setReservationId] = useState("");
  const [feedBack, setFeedBack] = useState(false);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  const [statusMenuDetail, setStatusDetail] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    // Use new API endpoint for parts reservation
    const link = masterAPI["partsReservation"]?.link;

    try {
      const res = await axiosPrivate.get(`${link}`);
      if (res.data.result) {
        // Map API response to expected table structure
        // const mappedData = res.data.result.map(item => ({
        //   id: item.id,
        //   code: item.code || '',
        //   partName: item.partName || '',
        //   workOrderId: item.workOrderPartsId || '',
        //   partId: item.partId || '',
        //   quantity: item.quantity || '',
        //   stockRoomName: item.stockRoomName || '',
        //   isActive: item.isActive,
        //   isDeleted: item.isDeleted,
        //   createdDate: item.createdDate,
        // }));

        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
      }
    } catch (e) {
      console.log(e, "parts reservation");
      setData([]);
      setBackUpData([]);
    }

    setIsLoading(false);
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };

  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleDelete = async (e, id, row) => {
    const enableLink = masterAPI["partsReservation"]?.enable;
    const disableLink = masterAPI["partsReservation"]?.disable;

    try {
      const partid = row.partId || row.partid || row.partID || row.part_id; // Try to get part id from row
      if (!partid) throw new Error("Missing partId for reservation");
      if (e.target.checked) {
        await axiosPrivate.put(`${enableLink}/${id}/${partid}`);
      } else {
        await axiosPrivate.put(`${disableLink}/${id}/${partid}`);
      }
      getData();
    } catch (e) {
      console.log(e, "enable/disable parts reservation");
    }
  };

  const handleCheck = (e, value) => {
    if (e.target.checked) {
      setReservationId(value);
    } else {
      setReservationId("");
    }
  };

  // Update columns to show available fields
  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
            <Box sx={{ width: color.checkBoxWidth }}>
                <Checkbox />
            </Box>
        );
      },
    },
    {
      Header: "Code",
      accessor: "code",
    },
      {
      Header: "Work Order Code",
      accessor: "workOrderCode",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         <Switch
    //           disabled={!actionAllow.delete}
    //           checked={cell.row.original.isActive}
    //           onChange={(e) => {
    //             handleDelete(e, cell.row.original.id, cell.row.original);
    //           }}
    //         />
    //       </Box>
    //     );
    //   },
    // },
  ];

  const menuStatusHandle = (value) => {
    console.log(value);
    setStatusDetail(value);
    if (value.value === "Cancelled") {
      setFeedBack(true);
    } else {
      handleMenuSelect(value, "");
    }
  }

  const handleMenuSelect = async (menuData, reason) => {
    setFeedBack(false);
    const putData = {
      id: reservationId,
      status: menuData.value,
      reasonToCancel: reason,
    };

    try {
      const statusLink = masterAPI["partsReservation"]?.update;
      await axiosPrivate.put(`${statusLink}`, putData);
      toast.success("Updated");
      getData();
      setReservationId("");
    } catch (e) {
      console.log(e, "error updating status");
    }
  };

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          Parts Reservation
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        statusList={reservationStatus}
        menuStatusHandle={menuStatusHandle}
        buttonDisable={true}
        changeStatusOption={reservationId !== ""}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"xl"}
        fullWidth
        children={
          <PartsReservationModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
      <Dialog
        open={feedBack}
        onClose={() => setFeedBack(false)}
        maxWidth={"lg"}
        children={
          <FeedBack
            handleCloseClick={(e) => handleMenuSelect(statusMenuDetail, e)}
            onCancel={() => {
              setFeedBack(false);
            }}
          />
        }
      />
    </>
  );
};

export default PartsReservation;

